export const sampleDashboard = {
    score: 91,

    zone: "Momentum",

    streak: {
        current: 42,
    },

    stats: {
        total: 90,
        done: 82,
        planned: 6,
        cancelled: 2,
        focusRate: 88,
    },

    signals: {
        focus: 88,
        consistency: 92,
        discipline: 90,
        resilience: 84,
        energy: 87,
    },

    trend: [25, 35, 45, 58, 67, 79, 91],

    behavior: {
        roachScore: 8,
        roachType: "Phoenix Survivor",
    },

    objectives: {
        distribution: {
            Learning: 28,
            Discipline: 22,
            Career: 16,
            Health: 10,
            Focus: 8,
            Growth: 6,
        },
    },

    insights: [
        "Consistency pattern becoming stronger every week.",
        "Gaming dependency reduced significantly after Week 4.",
        "Learning identity now dominates daily decision making.",
        "Focus recovery speed improved after distractions.",
        "Execution quality remained stable across difficult periods.",
    ],

    recommendedAction:
        "Increase deep-work blocks from 60 minutes to 90 minutes and introduce a fixed evening review ritual."
};